import { CallbackWith, ErrorHandlerCallback, ErrorInfo, Maybe, toErrorInfo } from '@csp/csp-common-model';
import { useCallback, useState } from 'react';
import { ErrorInfoState } from './model/ErrorInfoState';
import { ErrorInfoArgs } from './model/ErrorInfoArgs';

type Props = {
  getErrorMessage?: CallbackWith<Error, string>;
  errorHandler?: ErrorHandlerCallback;
  initialError?: ErrorInfo;
};

export const useErrorInfo = (props?: Props): ErrorInfoState => {
  const [errorInfo, setErrorInfoInternal] = useState<Maybe<ErrorInfo>>(props?.initialError);
  const getErrorMessage = props?.getErrorMessage;
  const errorHandler = props?.errorHandler;

  const setErrorInfo = useCallback(
    (errorArgs: ErrorInfoArgs): void => {
      const error = errorArgs.error as Error;
      const errorInfo = toErrorInfo({
        error,
        message: errorArgs.message ?? getErrorMessage?.(error),
      });
      if (!errorArgs.handled) {
        errorHandler?.(errorArgs);
      }

      setErrorInfoInternal(errorInfo);
    },
    [errorHandler, getErrorMessage],
  );

  const clearErrorInfo = useCallback((): void => setErrorInfoInternal(undefined), []);

  return {
    setErrorInfo,
    clearErrorInfo,
    errorInfo,
  };
};
